/*
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import React, { Fragment, useContext, useEffect, useState } from 'react'
import { Menu, Transition } from '@headlessui/react'
import {
  BanknotesIcon,
  BellIcon,
  DocumentDuplicateIcon
} from '@heroicons/react/24/outline'
import { AuthContext } from "../contexts/auth"
import { Link } from "wouter";
import { DataContext } from '../contexts/data'
import { menuItems } from '../stores/menuData'
import { useAtom } from 'jotai'
import { currentPageStore } from '../stores/mainStore'
import { getEmployeesWithActiveContract, getEmployeeCount } from '../services/api_calendar';
import { getJustificationRequestsCompanyList } from '../services/api_justification_requests';
import { listaRichiesteRimborsoSpeseCompany } from '../services/api_cost_refunds';
import { getSubscriptions } from '../services/api_subscriptions';
import moment from 'moment';
import OnBoarding from '../components/on_boarding';
import Fetching from '../components/fetching';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';

const bottonItems = [
  { name: 'Save and schedule', href: '#' },
  { name: 'Save and publish', href: '#' },
  { name: 'Export PDF', href: '#' },
]

const userNavigation = [
  // { name: 'Your Profile', href: '#' },
  // { name: 'Settings', href: '#' },
  // { name: 'Sign out', href: '#' },
]
const stats = [
  { label: 'Vacation days left', value: 12 },
  { label: 'Sick days left', value: 4 },
  { label: 'Personal days left', value: 2 },
]


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Root() {
  
  const { profile, token, isEmployee } = useContext(AuthContext)
  const {dipendentiGlobal, setDipendentiGlobal} = useContext(DataContext)

  const [fetchingEmployees, setFetchingEmployees] = useState(false)
  const [employees, setEmployees] = useState([]);

  const [currentPage, setCurrentPage] = useAtom(currentPageStore);

  const [menuOpen, setMenuOpen] = useState(false);
  const [pendingJustificationsCount, setPendingJustificationsCount] = useState(0);
  const [pendingRefundsCount, setPendingRefundsCount] = useState(0);

  const hasAlerts = profile && profile.level && Object.keys(profile.level).length > 0 && profile.level[Object.keys(profile.level)[0]].includes("alerts");
  const hasJustifications = profile && profile.level && Object.keys(profile.level).length > 0 && profile.level[Object.keys(profile.level)[0]].includes("justifications");

  const [subscriptions, setSubscriptions] = useState([]);
  const [isLoadingSubscriptions, setIsLoadingSubscriptions] = useState(false);
  const [subscriptionsError, setSubscriptionsError] = useState(null);

  const [showOnBoarding, setShowOnBoarding] = useState(false);
  const [isFirstOpen, setIsFirstOpen] = useState(true);

  const [fetchingEmployeeCount, setFetchingEmployeeCount] = useState(false);
  const [employeeCount, setEmployeeCount] = useState({ active: 0, inactive: 0, all: 0 });

  const [totalResult, setTotalResult] = useState(0);
  const [page, setPage] = useState(1);
  const pageSize = 15; 
  const hidePagination = !totalResult || (totalResult <= pageSize || totalResult === 0);

  const hasNoPlan = profile?.level?.no_plan?.length === 0; 
  
  useEffect(() => {
    setCurrentPage('/')
  }, [])

  // fetch informazions when token exists
  const fetchEmployees = (signal, skipOnboardingCheck = false) => {
    if (!token) return;

    if (!signal) {
      const controller = new AbortController();
      signal = controller.signal; 
    }
  
    setFetchingEmployees(true);
    let with_active_contract = 'all';
  
    getEmployeesWithActiveContract(token, null, with_active_contract, signal, page, pageSize, null, 'payrolls')
      .then((res) => {
        const employeesArray = Array.isArray(res.results) ? res.results : [];
        let filteredEmployees = employeesArray;
  
        setTotalResult(res.count);
        setEmployees(filteredEmployees);
  
        if (!skipOnboardingCheck) {
          if (res.count === 0 && profile?.customer_type === 'company') {
            setShowOnBoarding(true);
          } else {
            setShowOnBoarding(false);
          }
        }
  
        setFetchingEmployees(false);
      })
      .catch((err) => {
        if (err.name !== 'AbortError') {
          console.log(err);
          setFetchingEmployees(false);
        }
      }
    );
  };

  const fetchEmployeeCount = async () => {
    if (!token) return;
    setFetchingEmployeeCount(true);
    try {
      const response = await getEmployeeCount(token, 'payrolls');
      setEmployeeCount(response);
    } catch (error) {
      console.error('Errore nel recupero del conteggio dei dipendenti:', error);
    } finally {
      setFetchingEmployeeCount(false);
    }
  };
  
 

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;
  
    fetchEmployees(signal);
    if (profile.customer_type !== 'employee') {
      fetchEmployeeCount();
    }

    return () => controller.abort();
  }, [token, page]);

  const handleNextPage = () => {
    if (page * pageSize < totalResult) {
      setPage(prevPage => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      setPage(prevPage => prevPage - 1);
    }
  };

  useEffect(() => {
    if (token && (hasAlerts || hasJustifications)) {
      fetchNotifications();
    }
  }, [token, profile]);
  

  const fetchNotifications = async () => {
    try {
      if (hasJustifications) {
        const justificationRequestsData = await getJustificationRequestsCompanyList(token, '', '1', '', 'null');
        
        if (justificationRequestsData && Array.isArray(justificationRequestsData.results)) {
          const pendingJustifications = justificationRequestsData.count || 0; 
          setPendingJustificationsCount(pendingJustifications);
        } else {
          console.error('Unexpected justificationRequestsData structure:', justificationRequestsData);
          setPendingJustificationsCount(0);
        }
      }
  
      const expenseRefundsData = await listaRichiesteRimborsoSpeseCompany(token, 1, 'null', '', 'all', 'all');
  
      if (expenseRefundsData && Array.isArray(expenseRefundsData.results)) {
        const pendingRefunds = expenseRefundsData.count; 
        setPendingRefundsCount(pendingRefunds);
      } else {
        console.error('Unexpected expenseRefundsData structure:', expenseRefundsData);
        setPendingRefundsCount(0);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };


  useEffect(() => {
    const fetchSubscriptionsCompany = async () => {
      setIsLoadingSubscriptions(true);
      setSubscriptionsError(null);

      try {
        const subscriptionsData = await getSubscriptions(token);
        setSubscriptions(subscriptionsData);
        
      } catch (error) {
        console.error('Error fetching subscriptions:', error);
        setSubscriptionsError(error);
      } finally {
        setIsLoadingSubscriptions(false);
      }
    };

    if (token && profile?.customer_type === 'company') {
      fetchSubscriptionsCompany();
    }
  }, [token, profile]);


  const isProfileComplete = profile.has_complete_profile;
  

  return (
    <> 
      <div className="min-h-full">
        {/* <Popover as="header" className="bg-gradient-to-r from-purple-800 to-purple-400 pb-24"> */}
        
          {/* {({ open }) => (
            <>
              <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
                <div className="relative flex flex-wrap items-center justify-center lg:justify-between">
                  
                  <div className="w-full py-5 lg:border-t lg:border-white lg:border-opacity-20">
                    <span className='flex justify-end'><TourUtente /></span>
                    <div className="lg:grid lg:grid-cols-3 lg:items-center lg:gap-8"> */}
                      {/* Left nav */}
                      {/* <div className="hidden lg:col-span-2 lg:block"> */}
                        {/* <nav className="flex space-x-4">
                          {navigation.map((item) => (
                            <a
                              key={item.name}
                              href={item.href}
                              className={classNames(
                                item.current ? 'text-white' : 'text-cyan-100',
                                'rounded-md bg-white bg-opacity-0 px-3 py-2 text-sm font-medium hover:bg-opacity-10'
                              )}
                              aria-current={item.current ? 'page' : undefined}
                            >
                              {item.name}
                            </a>
                          ))}
                        </nav> */}
                      {/* </div>
                      <div className="px-12 lg:px-0"> */}
                        {/* Search */}
                        
                      {/* </div>
                    </div>
                  </div> */}

                  {/* Menu button */}
                  {/* <div className="absolute right-0 flex-shrink-0 lg:hidden">
                    <Popover.Button className="inline-flex items-center justify-center rounded-md bg-transparent p-2 text-cyan-200 hover:bg-white hover:bg-opacity-10 hover:text-white focus:outline-none focus:ring-2 focus:ring-white">
                      <span className="sr-only">Open main menu</span>
                      {open ? (
                        <XMarkIcon className="block h-6 w-6" />
                      ) : (
                        <Bars3Icon className="block h-6 w-6" />
                      )}
                    </Popover.Button>
                  </div> */}
                {/* </div>
              </div>

              <Transition.Root as={Fragment}>
                <div className="lg:hidden">
                  <Transition.Child
                    as={Fragment}
                    enter="duration-150 ease-out"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="duration-150 ease-in"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <Popover.Overlay className="fixed inset-0 z-20 bg-black bg-opacity-25" />
                  </Transition.Child>

                  <Transition.Child
                    as={Fragment}
                    enter="duration-150 ease-out"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="duration-150 ease-in"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                  >
                    <Popover.Panel
                      focus
                      className="absolute inset-x-0 top-0 z-30 mx-auto w-full max-w-3xl origin-top transform p-2 transition"
                    >
                      <div className="divide-y divide-gray-200 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                        <div className="pb-2 pt-3">
                          <div className="flex items-center justify-between px-4">
                            <div>
                              <img
                                className="h-8 w-auto"
                                src="https://tailwindui.com/img/logos/mark.svg?color=cyan&shade=600"
                                alt="Your Company"
                              />
                            </div>
                            <div className="-mr-2">
                              <Popover.Button className="inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-cyan-500">
                                <span className="sr-only">Close menu</span>
                                <XMarkIcon className="h-6 w-6" />
                              </Popover.Button>
                            </div>
                          </div>
                          <div className="mt-3 space-y-1 px-2">
                          </div>
                        </div>
                      </div>
                    </Popover.Panel>
                  </Transition.Child>
                </div>
              </Transition.Root>
            </>
          )} */}

          
        {/* </Popover> */}

        {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
          <div className="container mx-auto">
            <div className="bg-orange-100 text-orange-600 p-4 rounded-md">
              <p className="text-center text-sm font-semibold">
                Il profilo non è completo. <br />
                Compila i campi mancanti{' '}
                <Link
                  to="/profilo/fatturazione"
                  className="text-indigo-600 hover:text-indigo-800 underline"
                >
                  cliccando qui
                </Link>
                .
              </p>
            </div>
          </div>
        )}

        {profile?.customer_type === 'company' && (
          <div className="container mx-auto">
            {isLoadingSubscriptions ? (
              <div>Loading subscriptions...</div>
            ) : subscriptionsError ? (
              subscriptionsError.response?.status === 401 ? (
                <div className="text-center mt-2 text-sm font-semibold">
                  <span>Nessuna sottoscrizione attiva. </span>
                  <Link href="/livelli" className="text-indigo-600 underline">
                    Clicca qui
                  </Link>{' '}
                  per sottoscrivere un abbonamento.
                </div>
              ) : (
                <div>Error loading subscriptions: {subscriptionsError.message}</div>
              )
            ) : (
              subscriptions.length > 0 &&
              subscriptions.some((sub) => sub.status === 'trialing') && (
              <div className="text-center text-md font-semibold pt-2 bg-gray-50">
                <span className="text-indigo-700 uppercase tracking-wider pe-2">
                  Il periodo di prova terminerà il giorno 
                </span>
                {subscriptions
                  .filter((sub) => sub.status === 'trialing')
                  .map((sub) => (
                    <span key={sub.id} className="text-indigo-700 uppercase tracking-wider">
                      {moment(sub?.current_period_end).format('DD/MM/YYYY')} alle ore{' '}
                      {moment(sub?.current_period_end).format('hh:mm')}
                    </span>
                  ))}
              </div>
              )
            )}
          </div>
        )}

        {showOnBoarding && !fetchingEmployees ? (
          <OnBoarding
            token={token}
            isFirstOpen={isFirstOpen}
            onComplete={() => {
              setShowOnBoarding(false);
              fetchEmployees(null, true);
              fetchEmployeeCount();
            }}
          />
        ) : (
          <>
            <div className='flex justify-end ml-6 sm:mr-6 mt-6'>
              <span className='me-4 mt-1'>
                <a
                  href="https://consultalahr.com/videoguida/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-x-2 rounded-md bg-white pl-3 pr-4 py-2 text-sm font-semibold text-gray-900 shadow-md ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-indigo-500"
                >
                  <QuestionMarkIcon className="w-5 h-5 text-gray-800" />
                  <span>Aiuto</span>
                </a>
              </span>
              <div className='relative'>
                <Menu as="div" className="relative inline-block text-left">
                  {profile && profile.level && Object.keys(profile.level).length > 0 && profile.level[Object.keys(profile.level)[0]].includes("alerts") && (
                    <Menu.Button className="flex items-center sm:flex-row-reverse">
                      <BellIcon className='w-8 h-8 text-gray-500 cursor-pointer ml-0 sm:ml-auto mt-2 me-1' />
                      {(pendingJustificationsCount > 0 || pendingRefundsCount > 0) && (
                        <span className='absolute top-0 right-0 flex items-center justify-center h-4 w-4 rounded-full ring-2 ring-white bg-red-500 text-white text-xs font-bold'>
                          {pendingJustificationsCount + pendingRefundsCount}
                        </span>
                      )}
                    </Menu.Button>
                  )}
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    {/* Per schermi piccoli il menu si apre verso destra, per sm in su verso sinistra */}
                    <Menu.Items className="absolute sm:right-0 mt-2 w-64 origin-top-right bg-white border border-gray-200 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                      <div className="py-1">
                        {pendingJustificationsCount > 0 ? (
                          <Menu.Item>
                            {({ active }) => (
                              <Link href="/pending_justifications">
                                <a
                                  className={classNames(
                                    active ? 'bg-gray-100' : '',
                                    'block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100 hover:font-semibold'
                                  )}
                                >
                                  Hai {pendingJustificationsCount === 1 ? '1 richiesta di giustificativo da gestire' : ` ${pendingJustificationsCount} richieste di giustificativi da gestire`}
                                </a>
                              </Link>
                            )}
                          </Menu.Item>
                        ) : null}

                        {pendingRefundsCount > 0 ? (
                          <Menu.Item>
                            {({ active }) => (
                              <Link href="/refund_requests">
                                <a
                                  className={classNames(
                                    active ? 'bg-gray-100' : '',
                                    'block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100 hover:font-semibold'
                                  )}
                                >
                                  Hai {pendingRefundsCount === 1 ? '1 richiesta di rimborso spesa da gestire' : ` ${pendingRefundsCount} richieste di rimborso spesa da gestire`}
                                </a>
                              </Link>
                            )}
                          </Menu.Item>
                        ) : null}

                        {pendingJustificationsCount === 0 && pendingRefundsCount === 0 ? (
                          <Menu.Item>
                            {({ active }) => (
                              <span
                                className={classNames(
                                  active ? 'bg-gray-100' : '',
                                  'block px-4 py-2 text-sm text-gray-700'
                                )}
                              >
                                Nessuna notifica
                              </span>
                            )}
                          </Menu.Item>
                        ) : null}
                      </div>
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
            </div>

            <main className="w-auto min-w-full max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8 mt-4">
              <h2 className="text-sm font-medium text-gray-900">Collegamenti Rapidi</h2>
              <ul className="mt-3 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 xl:grid-cols-4 pb-6">
                {menuItems.map((action) => {
                  if (action.isRapid) {
                    return (
                      <li key={action.href} className="relative col-span-1 flex rounded-md shadow-sm">
                        <Link to={`${action.href}`} className="text-gray-900 font-medium hover:text-gray-600 flex w-full">
                          <div
                            className={classNames(
                              action.iconBackground,
                              'flex w-16 flex-shrink-0 items-center justify-center rounded-l-md text-sm font-medium text-white py-6'
                            )}
                          >
                            <action.icon className={classNames(action.iconForeground, "h-8 w-8")} />
                          </div>
                          <div className="flex flex-1 items-center justify-between truncate rounded-r-md border-b border-r border-t border-gray-200 bg-white">
                            <div className="flex-1 truncate px-4 py-2 text-sm">
                              {action.name}
                            </div>
                          </div>
                        </Link>
                      </li>
                    );
                  }
                  return null;
                })}
              </ul>
              
              { (hasAlerts || hasJustifications) && (
                <>
                  <h2 className='text-sm font-medium text-gray-900 border-t pt-4'>Notifiche</h2>
                  <div className="mt-3 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 xl:grid-cols-2">
                  <div className="relative col-span-1 flex rounded-md shadow-sm">
                    <Link to={`/pending_justifications`} className="text-gray-900 font-medium hover:text-gray-600 flex w-full">
                      <div className='bg-indigo-200 flex w-16 flex-shrink-0 items-center justify-center rounded-l-md text-sm font-medium text-indigo-800 py-6'>
                        <DocumentDuplicateIcon className="h-8 w-8" />
                      </div>
                      <div className="flex flex-1 items-center justify-between truncate rounded-r-md border-b border-r border-t border-gray-200 bg-white">
                        <div className="flex-1 px-4 py-2 text-sm">
                          {pendingJustificationsCount > 0 ? (
                            <>
                              Hai <span className="text-red-500 font-bold text-sm">
                                {pendingJustificationsCount === 1 ? '1' : pendingJustificationsCount}
                              </span> 
                              {pendingJustificationsCount === 1 ? ' richiesta di giustificativo da gestire' : ' richieste di giustificativi da gestire'}
                            </>
                          ) : (
                            'Nessuna richiesta di giustificativo da gestire'
                          )}
                        </div>
                      </div>

                    </Link>
                  </div>
                  <div className="relative col-span-1 flex rounded-md shadow-sm">
                    <Link to={`/refund_requests`} className="text-gray-900 font-medium hover:text-gray-600 flex w-full">
                      <div className='bg-indigo-200 flex w-16 flex-shrink-0 items-center justify-center rounded-l-md text-sm font-medium text-indigo-800 py-6'>
                        <BanknotesIcon className="h-8 w-8" />
                      </div>
                      <div className="flex flex-1 items-center justify-between truncate rounded-r-md border-b border-r border-t border-gray-200 bg-white">
                        <div className="flex-1 px-4 py-2 text-sm">
                          {pendingRefundsCount > 0 ? (
                            <>
                              Hai <span className="text-red-500 font-bold text-sm">
                                {pendingRefundsCount === 1 ? '1' : pendingRefundsCount}
                              </span> 
                              {pendingRefundsCount === 1 ? ' richiesta di rimborso spesa da gestire' : ' richieste di rimborso spesa da gestire'}
                            </>
                          ) : (
                            'Nessuna richiesta di rimborso spesa da gestire'
                          )}
                        </div>
                      </div>
                    </Link>
                  </div>
                  </div>
                </>
              )}
            </main>
            <hr className="mt-8" />
            <div className=" sm:block">
              <div className="inline-block min-w-full border-b border-gray-200 align-middle">
                <div className="border-b border-gray-200 px-4 py-4 flex items-center justify-between sm:px-6 lg:px-8">
                  <div className="flex-1 min-w-0">
                    <h1 className="text-lg font-medium leading-6 text-gray-900 truncate">Lista Dipendenti</h1> 
                    {fetchingEmployeeCount ? (
                      <span className='text-xs'>Caricamento...</span>
                    ) : (
                      <span className="text-xs leading-normal block">
                        <div>Totale dipendenti creati: {employeeCount?.all}</div>
                        <div>Attivi: {employeeCount?.active}, Non attivi: {employeeCount?.inactive}</div>
                      </span>
                    )}
                  </div>
                  {!hasNoPlan && (
                    <button
                      onClick={() => {
                        setIsFirstOpen(false);
                        setShowOnBoarding(true);
                      }}
                      className="ml-4 px-4 py-2 text-sm font-semibold rounded-md focus:outline-none bg-indigo-600 hover:bg-indigo-500 text-white shadow-md whitespace-nowrap">
                      Creazione Rapida Dipendenti
                    </button>
                  )}
                </div>
                <table className="min-w-full">
                  <thead>
                    <tr className="border-t border-gray-200">
                      <th
                        className="w-28 border-b border-gray-200 bg-gray-50 py-3 pr-6 text-right text-sm font-semibold text-gray-900"
                        scope="col"
                      >
                        
                      </th>
                      <th
                        className="border-b border-gray-200 bg-gray-50 px-6 py-3 text-left text-sm font-semibold text-gray-900"
                        scope="col"
                      >
                        <span className="lg:pl-2">Cognome e Nome</span>
                      </th>
                      <th
                        className="border-b border-gray-200 bg-gray-50 px-6 py-3 text-left text-sm font-semibold text-gray-900"
                        scope="col"
                      >
                        Codice Fiscale
                      </th>
                      <th
                        className="hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-left text-sm font-semibold text-gray-900 md:table-cell"
                        scope="col"
                      >
                        Email
                      </th>
                      <th
                        className="border-b border-gray-200 bg-gray-50 py-3 pr-6 text-right text-sm font-semibold text-gray-900"
                        scope="col"
                      >
                        Azioni
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100 bg-white">
                    {fetchingEmployees ? (
                      <tr>
                        <td colSpan={5}>
                          <Fetching />                          
                        </td>
                      </tr>
                    ) : (
                      <>
                        {employees && employees.length > 0 ? (
                          employees
                          .sort((a, b) => {
                            const aValue = a.last_name || a.cf;
                            const bValue = b.last_name || b.cf;
                            return aValue.localeCompare(bValue);
                          })
                          .map((emp) => (
                            <tr key={emp.id} className='px-2'>
                              <td className="w-28 whitespace-nowrap pl-6 pr-2 py-3 text-sm font-medium text-center">
                              {emp?.app_activate && emp?.active_contract ? (
                                <span className="inline-flex justify-center items-center rounded-md px-0.5 py-1 text-xs font-semibold shadow-sm w-full text-green-500 bg-green-100">Attivo</span>
                              ) : (
                                <span className="inline-flex justify-center items-center rounded-md px-0.5 py-1 text-xs font-semibold shadow-sm w-full text-gray-500 bg-gray-100">Non attivo</span>
                              )}
                              </td>
                              <td className=" whitespace-nowrap py-3 text-sm font-medium text-gray-900">
                                <div className="flex items-center space-x-3 lg:pl-2">
                                  <div
                                    className={classNames(emp.bgColorClass, 'h-2.5 w-2.5 flex-shrink-0 rounded-full')}
                                  />
                                  <a href="#" className="truncate hover:text-gray-600">
                                    <span>
                                      {emp.last_name} {emp.first_name} 
                                    </span>
                                  </a>
                                </div>
                              </td>
                              <td className="px-6 py-3 text-sm font-medium text-gray-500">
                                <div className="flex items-center space-x-2">
                                  <div className="flex flex-shrink-0 -space-x-1">
                                    <span className="font-normal text-gray-500">
                                      {emp.cf?.toUpperCase()}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td className="hidden whitespace-nowrap px-6 py-3 text-left text-sm text-gray-500 md:table-cell">
                                {emp.email_auth}
                              </td>
                              <td className="whitespace-nowrap px-6 py-3 text-right text-sm font-medium">
                                <Link to={`/dipendenti/${emp.cf}`}
                                  className="inline-flex items-center rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                                  Apri
                                </Link>
                              </td>
                            </tr>
                        ))) : (
                          <tr>
                            <td colSpan={5} className="m-4 rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                            <span className="mt-2 text-sm font-semibold text-gray-900">Non sono presenti dipendenti con contratto attivo</span>
                            </td>
                          </tr>
                        )} 
                      </>
                    )}
                  </tbody>
                </table>
                {!hidePagination && (
                  <div className="flex justify-between my-6 px-6">
                    <button 
                      className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                      onClick={handlePreviousPage}
                      disabled={page === 1}
                    >
                      Precedente
                    </button>
                    <span className='text-sm font-medium text-gray-900'>Pagina {page} di {Math.ceil(totalResult / pageSize)}</span>
                    <button 
                      className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                      onClick={handleNextPage} 
                      disabled={page * pageSize >= totalResult}
                    >
                      Successivo
                    </button>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
        
        <footer>
          <div className="mx-auto max-w-3xl px-4 pt-8 sm:px-6 lg:max-w-7xl lg:px-8">
            <div className="border-t border-gray-200 py-8 text-center text-sm text-gray-500 sm:text-left">
              <span className="block sm:inline">&copy; {new Date().getFullYear()} Consultala SRL</span>{' '}
              <span className="block sm:inline">All rights reserved.</span>
            </div>
          </div>
        </footer>
      </div>
    </>
  )
}
